<div class="questionnaire-field-spacer d-flex flex-column">
    <p-inputnumber [formControl]="formControl"
                   [mode]="props.mode"
                   [currency]="props.currencyName"
                   [min]="props.min"
                   [max]="props.max"
                   [minFractionDigits]="props.minFractionDigits"
                   [maxFractionDigits]="props.maxFractionDigits"></p-inputnumber>
    <formly-validation-message [field]="field" *ngIf="formControl?.invalid &&
  formControl?.dirty" />
</div>
